import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'react-router-redux'
import { useAbility } from 'utilities/ability'
import { WIZARD_QUICK_START_PATH } from '../routes'

const t = buildTranslate('recovery_ai.settings.setup_guide')

// Settings → Setup guide (flag: recovery-ai-setup-guide). The button is
// navigation-only — it writes nothing. Persistence lives inside the wizard: the
// Locations stage has an isDirty-gated Save, and Finalize re-PUTs the escalation
// fields. On re-entry Finalize preserves launch-time fields it has no UI for
// (operating_mode) and is blocked if the current config failed to load (AI-580),
// so a re-walk can't silently downgrade or clobber live settings. Manager-only
// (mirrors EscalationRulesPane) so a view-only operator isn't bounced to `/`.
const SetupGuidePane = () => {
  const dispatch = useDispatch()
  const ability = useAbility()
  const canManage = ability.can('manage', 'MerchantSettings')

  return (
    <div className="p-l">
      <Text.Header3 bold>{t('title')}</Text.Header3>
      <Text.BodyText3 color="grey70" className="mt-xs">
        {t('description')}
      </Text.BodyText3>
      {/* Button sits in its own block-level row so it drops below the copy
          instead of flowing inline after the (inline) description text —
          mirrors EscalationRulesPane's `mt-l` button footer. */}
      {canManage && (
        <div className="mt-l">
          <Button
            kind="primary"
            onClick={() => dispatch(push(WIZARD_QUICK_START_PATH))}
            aria-label={t('button_aria_label')}
          >
            {t('button')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default SetupGuidePane
